export default {"src":"/_next/static/media/account-icon.6a9d740d.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};